import { useDataBoxStatus } from 'app/common/data-box-store'

import { acquiringSettings } from '../dataBox'


export function useAcquiringSettingsLoading() {
  const ready = useDataBoxStatus(acquiringSettings, () => acquiringSettings.ready)
  return !ready
}
